<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper" style="padding-bottom: 0rem">
        <div class="col-12">
          <div class="element-box mb-0">
            <h5 class="form-header">Requisiciones Pendientes de Traslados</h5>
            <div class="row">
              <div class="col-6">
                <TiendaSelectComponent :current="current" />
              </div>
              <div class="col-sm-6">
                <ProductoSelectComponentV2 :current="current" />
              </div>
              <div class="col-12">
                <button
                  class="btn btn-sm btn-success btn-block"
                  @click="refresh()"
                  v-if="current.tienda && current.producto"
                >
                  Refrescar Busqueda
                </button>
                <br />
                <button
                  class="btn btn-sm btn-primary btn-block"
                  @click="imprimir"
                  v-if="current.tienda && current.producto"
                >
                  Imprimir total solicitudes PDF
                </button>
                <br />
                <button
                  class="btn btn-sm btn-dark btn-block"
                  @click="cleanFilters"
                  v-if="current.tienda && current.producto"
                >
                  Limpiar Busqueda
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="element-box">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>producto</th>
                  <th>Unidad medida</th>
                  <th>Cantidad um</th>
                  <th>Tienda</th>
                  <th class="text-right">Cantidad Abierta</th>
                  <th class="text-right">Fecha creación</th>
                  <th class="text-right">Usuario</th>
                  <th class="text-right"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in datos" :key="item.id">
                  <td>{{ item.producto_id }} - {{ item.nombre_producto }}</td>
                  <td>{{ item.unidad_medida }}</td>
                  <td>{{ item.cantidad_um }}</td>
                  <td>{{ item.tienda_id }}</td>
                  <td class="text-right">{{ item.cantidad_abierta }}</td>
                  <td class="text-right">
                    {{ item.fecha_creacion | moment("DD/MM/YYYY hh:mm:ss a") }}
                  </td>
                  <td class="text-right">{{ item.username }}</td>
                  <td class="text-right">
                    <div class="btn-group dropleft">
                      <a
                        class="btn btn-secondary dropdown-toggle"
                        href="#"
                        role="button"
                        id="dropdownMenuLink"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fas fa-cog"></i>
                      </a>

                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <a
                          class="dropdown-item"
                          @click="ver_requisicion(item.req_traslado_e_id)"
                        >
                          <i class="fas fa-eye"></i> VER</a
                        >
                        <a
                          class="dropdown-item"
                          :disabled="item.cantidad_abierta == 0"
                          @click="DarDeBajaReq(item)"
                          href="#"
                        >
                          <i class="fas fa-archive"></i> DAR DE BAJA</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    TiendaSelectComponent,
    ProductoSelectComponentV2,
  },
  data() {
    return {
      current: {
        tienda: null,
        producto: "",
        categoria: "",
        errors: {
          productos: null,
        },
      },
      datos: [],
      categorias: [],
    };
  },

  computed: {},
  mounted() {
    let self = this;
  },
  methods: {
    DarDeBajaReq(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Dar de Baja a Requerimiento",
        "¿Esta seguro de dar de baja la linea?",
        "Si",
        function () {
          DynamicService.postAction(
            "inv",
            "req_traslado",
            detalle.req_traslado_e_id,
            "dar_de_baja_solicitud",
            {
              linea: detalle.id.replace(/-/g, ""),
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Dar de Baja a Requerimiento",
                "Se ha eliminado la Información."
              );
              self.refresh();
            })
            .catch((error) => {
              self.current.errors = error.response.data;

              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Dar de Baja a Requerimiento",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    imprimir() {
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/Req_traslados/solicitudes_por_tienda_sku.jrxml&producto_id=${this.current.producto.sku}&tienda_id=${this.current.tienda}`
      );
    },
    ver_requisicion(id) {
      let self = this;
      let routeUrl = this.$router.resolve({
        name: "inventario-req_traslado-editar",
        params: { id: id },
      });
      window.open(routeUrl.href, "_blank");
    },
    cleanFilters() {
      this.current.tienda = null;
      this.current.producto = null;
      this.current.categoria = null;
      this.datos = "";
    },
    refresh() {
      let self = this;
      let tienda = null;
      let sku = null;
      let categoria = null;
      if (this.current.tienda) {
        tienda = this.current.tienda;
      }
      if (this.current.producto) {
        sku = this.current.producto.sku;
      }
      let params = {
        tienda: tienda,
        sku: sku,
        categoria: categoria,
      };
      DynamicService.getActionList(
        "inv",
        "req_traslado",
        "req_abiertas",
        params
      )
        .then((res) => {
          self.datos = res.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>
